<template>
    <div id="container-search-bar" class="relative flex h-10 items-center max-md:w-11/12 max-md:mx-auto">
        <input @keyup="execFilter()" v-model="filter" @keypress.enter="execFilter()" type="text" name="search-bar" id="bar" class="form-input-special dark:text-primary-dark-text max-md:text-content-mobile">
        <div @click="execFilter()" class="absolute rounded-full h-full w-10 flex justify-center items-center bg-primary-color-1st dark:bg-primary-dark-color-1st">
            <font-awesome-icon icon="search" class="dark:text-primary-dark-text"/>
        </div>
        <shopping-cart v-if="store.isMovil" />
    </div>
    <submenu v-if="store.isMovil" class="pt-middle" />
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import { generalStore } from '@/stores';
import { shoppingCart } from '@/stores/shoppingCart';
import submenu from './Submenu.vue';
import ShoppingCart from './ShoppingCart.vue';

const store = generalStore();
var filter = ref('')

watchEffect(()=>{
    if(store.route.name){
        filter.value = ''
    }
})

const execFilter = async () => {
    var size = ref((filter.value.toString().length));
    if (size.value > 0) {
        var lastChar = ref(filter.value[size.value - 1].toString());
        if (store.validChar(lastChar.value) || lastChar.value.charCodeAt(0) == 32) {
            if (store.filterC) {
                await store.filterData(filter.value, store.getSessionStorage('persistSearch')['cat'], 'Multiple')
            } else {
                await store.filterData(filter.value, '', 'Name')
            }
        } else {
            filter.value = ((filter.value).toString()).substring(0, size.value - 1);
        }
    } else {
        filter.value = '';
        store.filterN = false;
        store.notFound = false;
        if (store.filterC) {
            store.filterData('', store.getSessionStorage('persistSearch')['cat'], 'Cat')
        }
    }
}

</script>
